module.exports = __webpack_public_path__ + "media/images/sun-472d153b4a7b00d5aed82285f91380eb.png";